export default "__VITE_ASSET__BRRcSjz3__"